/**
 * Generate a UUID (Universally Unique Identifier).
 * Uses the browser's crypto API to generate a random UUID if available,
 * otherwise falls back to a manual implementation.
 *
 * @returns {string} A randomly generated UUID.
 */
export function createUUID() {
  return (
    globalThis.crypto?.randomUUID?.() ||
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (
        +c ^
        (globalThis.crypto.getRandomValues(new Uint8Array(1))[0] &
          (15 >> (+c / 4)))
      ).toString(16)
    )
  );
}
